/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NewUserConfirmationAliases {
  BUTTON_ACCESS = 'button-access',
  IMAGE_0 = 'image-0',
  IMAGE_ERROR = 'image-error',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_ERROR = 'layout-error',
  LOADER = 'loader',
  MODAL_0 = 'modal-0',
  PANEL_1 = 'panel-1',
  PANEL_3 = 'panel-3',
  PANEL_ERROR = 'panel-error',
  PANEL_ERROR_IMAGE = 'panel-error-image',
  PANEL_LOADER = 'panel-loader',
  PANEL_NEW_USER_CONFIRMATION = 'panel-new-user-confirmation',
  PANEL_SUCCESS = 'panel-success',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_ERROR = 'text-error',
}
export { NewUserConfirmationAliases };
